var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isNeedTopSpace)?_c('div',{staticClass:"section-space-50"}):_vm._e(),_vm._v(" "),_c('section',{class:[
      'section-empty-state ',
      _vm.isClass && _vm.isClass.length > 0 ? _vm.isClass : '' ]},[_c('div',{staticClass:"text-muted text-center"},[_c('img',{staticClass:"d-table mx-auto mb-3 opacity-50",attrs:{"height":"100","width":"100","src":_vm.emptyImage}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.emptyMessage)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-663c6247","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/EmptyState.vue
// module id = null
// module chunks = 